<template>
  <el-tabs v-model="card_index">
    <el-tab-pane label="待审核" name="ThirdPartyLegalPlan">
      <ThirdPartyLegalPlan v-if="card_index==='ThirdPartyLegalPlan'" :urge_type="urge_type" />
    </el-tab-pane>
    <el-tab-pane label="审核中" name="ThirdPartyLegalPlan1">
      <ThirdPartyLegalPlan1 v-if="card_index==='ThirdPartyLegalPlan1'" :urge_type="urge_type" />
    </el-tab-pane>
    <el-tab-pane label="审核通过" name="ThirdPartyLegalPlan2">
      <ThirdPartyLegalPlan2 v-if="card_index==='ThirdPartyLegalPlan2'" :urge_type="urge_type" />
    </el-tab-pane>
    <el-tab-pane label="驳回" name="ThirdPartyLegalPlan3">
      <ThirdPartyLegalPlan3 v-if="card_index==='ThirdPartyLegalPlan3'" :urge_type="urge_type" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import ThirdPartyLegalPlan from "./ThirdPartyLegalPlan";
import ThirdPartyLegalPlan1 from "./ThirdPartyLegalPlan1";
import ThirdPartyLegalPlan2 from "./ThirdPartyLegalPlan2";
import ThirdPartyLegalPlan3 from "./ThirdPartyLegalPlan3";

export default {
  name: "ThirdPartyLegalMainPlan",
  components: {ThirdPartyLegalPlan3, ThirdPartyLegalPlan2, ThirdPartyLegalPlan1, ThirdPartyLegalPlan},
  inject:['where','reginWhere'],
  props: {
    urge_type:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  data(){
    return{
      card_index:"ThirdPartyLegalPlan",

    }
  },
  mounted() {

  },
  methods:{

  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/ThirdPartyLegalMainPlan.vue